module.exports = __webpack_public_path__ + "img/image 22.17f08643.png";